import React from 'react';
import { useState, useEffect, useRef } from 'react';
import "./error-page.scss";
import img from "../../assets/images/error-page/banner.png";
import meta_tags from '../../Data/MetaTags';
import {
  useLocation,
} from 'react-router-dom';
function ErrorPage() {

  const [rendercount, setRenderCount] = useState(() => false);

  const location = useLocation();


  useEffect(() => {
    setRenderCount(true)
    if (rendercount === true) {
      document.title = meta_tags[location.pathname.replace('/', "")] ? meta_tags[location.pathname.replace('/', "")].title : '';
      document.getElementById('meta-tags').content = meta_tags[location.pathname.replace('/', "")] ? meta_tags[location.pathname.replace('/', "")].content : '';
      document.getElementById('canonical-link').href = meta_tags[location.pathname.replace('/', "")] ? meta_tags[location.pathname.replace('/', "")].link : '';
      if(!(document.getElementById('link1')==null)){
        document.getElementById('link1').remove();
      document.getElementById('link2').remove();
      document.getElementById('link3').remove();
      document.getElementById('link4').remove();
      document.getElementById('link5').remove();
      document.getElementById('link6').remove();
      }
    }
  }, [rendercount])


  return (
    <>
      <section className='main-sec'>
          <div className='container'>
            <div className='error-details'>
                <div className='error-content'>
                    <h1>404</h1>
                    <p>We’re working on it!</p>
                </div>
                <div className='error-img'>
                    <img src={img} className="img-fluid"/>
                </div>
                <div className='btn-sec'>
                    <a href='/' className='btn btn-error'>Go Home</a>
                </div>
            </div>
          </div>
      </section>
    </>
  )
}

export default ErrorPage;
